// auth.normalize.ts
import type { AuthUser } from '@/shared/types';

export const normalizeAuthUser = (
  u: Partial<AuthUser> | null | undefined,
): AuthUser | null => {
  if (!u) return null;

  return {
    email: u.email ?? '',
    phone: u.phone ?? null,
    name: u.name ?? null,
    userId: u.userId,
    designation: u.designation ?? null,

    roles: Array.isArray(u.roles) ? u.roles : [],
    permissions: Array.isArray(u.permissions) ? u.permissions : [],

    is2FAEnabled: u.is2FAEnabled,
    isSuperuser: u.isSuperuser,
    isActive: u.isActive,
  };
};
